import { roleTypes } from '../types';

import { Departments } from '@/types';

export type PlatformKey = 'instagram' | 'telegram';

// Prophet does not allow 'unassigned' — server validates this in parse-page-access.ts.
export const PROPHET_DEPARTMENTS: roleTypes.PageAccessDepartment[] = [
  ...Object.values(Departments),
];

// Integrations allow all departments including 'unassigned'.
export const INTEGRATION_DEPARTMENTS: roleTypes.PageAccessDepartment[] = [
  ...Object.values(Departments),
  'unassigned',
];

export const DEPARTMENTS_BY_SECTION: Record<
  keyof roleTypes.PageAccessConfig,
  roleTypes.PageAccessDepartment[]
> = {
  prophet: PROPHET_DEPARTMENTS,
  integrations: INTEGRATION_DEPARTMENTS,
};

export const SECTIONS: {
  key: keyof roleTypes.PageAccessConfig;
  label: string;
  departments: roleTypes.PageAccessDepartment[];
}[] = [
  { key: 'prophet', label: 'Prophet', departments: PROPHET_DEPARTMENTS },
  { key: 'integrations', label: 'Integrations', departments: INTEGRATION_DEPARTMENTS },
];

export const PLATFORMS: { key: PlatformKey; label: string }[] = [
  { key: 'instagram', label: 'Instagram' },
  { key: 'telegram', label: 'Telegram' },
];
